import axios from 'axios';
import { getErrorMessage, getApiFileName } from '@/utils/api';

import { factory } from './factory';
import { getProcessingRequestFileResponse } from './interceptors/getProcessingRequestFile';

const responseInterceptors = [getProcessingRequestFileResponse];

const createApi = () => {
  axios.interceptors.response.use(res => responseInterceptors.reduce((acc, value) => value(acc), res));

  const methods = factory(axios);

  return {
    methods,
    getErrorMessage,
    getApiFileName,
  };
};

export const api = createApi();
